// @ts-nocheck
import { LazyImageStyle } from "@insite/mobius/LazyImage";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { TagWrapperProps } from "@store/Library/Components/Toolkit/TagWrapper";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { spacingStyles } from "@toolkit/Themes/common/mixins/spacing";
import { css } from "styled-components";

export interface BadgeProps {
    tagWrapper?: TagWrapperProps;
    badgeAreaWrapper?: InjectableCss;
    badgeTextWrapper?: InjectableCss;
    badgeText?: TypographyPresentationProps;
    badgeImageWrapper?: InjectableCss;
}

export const badgeProps: BadgeProps = {
    tagWrapper: {
        gap: pxToRem(7),
        extendedStyles: {
            wrapper: {
                css: css`
                    ${x => spacingStyles(x.theme.design.typography.spacing.base, null)}
                `,
            },
        },
    },
    badgeAreaWrapper: {
        css: css`
            position: relative;
        `,
    },
    badgeTextWrapper: {
        css: css`
            position: absolute;
        `,
    },
    badgeText: {
        css: css`
            ${({ theme }) => css`
                font-size: ${theme.design.typography.size.tiny};
                font-weight: ${theme.design.typography.weight.bold};
            `}
        `,
    },
    badgeImageWrapper: {
        css: css`
            position: absolute;
            width: 4em;
            height: auto;
            pointer-events: none;

            ${LazyImageStyle} {
                background-color: ${getColor("common.background")};
            }
        `,
    },
};
